export const selectedSiteKey = Symbol();

export const sitesKey = Symbol();

export const userKey = Symbol();

export const chatCompactKey = Symbol();
